import React, { lazy } from 'react';
import { AppRoute } from '../routes.types';
import ConnectMarketplaceDashboard from '../../containers/ConnectMarketplaceDashboard/ConnectMarketplaceDashboard';
import MeetingLinkRedirect from '../../containers/MeetingLinkRedirect/MeetingLinkRedirect';
import PracticeBrokerageServicesComponant from '../../containers/PracticeBrokerageServices/PracticeBrokerageServices';

const ConnectPage = lazy(
    () => import('../../venues/pages/ConnectPage/ConnectPage')
);
const BuyerMarketplace = lazy(
    () => import('../../containers/Admin/BuyerMarketplace/BuyerMarketplace')
);

export const CONNECT_ROUTES: AppRoute[] = [
    { path: '', element: <ConnectPage /> },
    { path: 'opportunities', element: <BuyerMarketplace /> },
    {
        path: 'engagement/:engagementId',
        element: <ConnectMarketplaceDashboard />,
    },
    { path: 'meetings', element: <MeetingLinkRedirect />, withAppShell: true },
    {
        path: 'practice-brokerage-services/:isComingSoon?',
        element: <PracticeBrokerageServicesComponant />,
    },
];
